import api from '../../api/index';
import config from '../../../static/config.json';
import qs from "qs";

const state = {
  login: false,
}
const mutations = {
  setLogin(state, data) {
    state.login = data;
  },
}
const getters = {
  getLogin: (state) => {
    return state.login;
  },
}
const actions = { 
  refresToken({
      rootState,
      commit
    }, id) { // 刷新token 30天
    return new Promise((resolve, reject) => {
      const exId = id || rootState.exhibitionId;
      const url = exId ? `?exhibitionId=${exId}` : '';
      api.get(`${config.https.api}/api/v1/member/current${url}`, rootState.tokenHeaders).then(data => {
        if (data.data) {  
          commit('setUserInfo', data.data.data, { root: true });
          commit('setUserId', data.data.data.userId, { root: true });
          commit('setInMemberId', data.data.data.inMemberId, { root: true });
          commit('setUserRole', data.data.data.userRole, { root: true });
          commit('setIsHasGetUser', true, { root: true });
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getUser({ rootState, commit },id) { // 获取用户信息
    return new Promise((resolve, reject) => {
      const exId = id || rootState.exhibitionId;
      const url = exId ? `?exhibitionId=${exId}` : '';
      api.get(`${config.https.api}/api/v1/member/current${url}`, rootState.tokenHeaders).then(data => {
        if (data.data) {  
          commit('setUserInfo', data.data.data, { root: true });
          commit('setUserId', data.data.data.userId, { root: true });
          commit('setInMemberId', data.data.data.inMemberId, { root: true });
          commit('setRole', data.data.data.userRole, { root: true });
          commit('setIsHasGetUser', true, { root: true });
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  registryUser({ rootState, commit } , opt) { //注册普通用户或修改普通买家信息
    return new Promise((resolve, reject) => {
      api.post(`${config.https.api}/api/v1/member/register-genrtalbuyer`,opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  modifyUser({ rootState, commit } , opt){ //修改用户部分属性
    return new Promise((resolve, reject) => {
      api.patch(`${config.https.api}/api/v1/member?id=${rootState.userInfo.id}`,opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  editUser({ rootState, commit } , opt) { //修改用户信息
    return new Promise((resolve, reject) => {
      api.patch(`${config.https.api}/api/v1/member?id=${rootState.userInfo.id}`,opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  editUserRole({ rootState, commit } , opt) { //修改用户状态值
    return new Promise((resolve, reject) => {
      api.patch(`${config.https.api}/api/v1/exhibitioninmember?id=${rootState.userInfo.inMemberId}`,opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        resolve(false);
      });
    });
  },
  getToken({ rootState, commit }, opt) { // 获取token   
    return new Promise((resolve, reject) => {
      api.post(`${config.https.auth}/connect/token`, qs.stringify(opt), rootState.formHeaders).then(data => {
        if (data.data) {
          commit('setAuth', data.data, { root: true })
          commit('setToken',  data.data.access_token, { root: true }); 
          localStorage.setItem(
            "expires_in",
            Date.now() + Number(data.data.expires_in) * 1000
          );
          resolve(data.data);
        }
      }).catch((err) => {
        let req = err.response;
        if (req && req.data && req.data.error_description) {
          if (req.data.code === 4002) {
            this.$toast.fail({ content: '登录身份有误，请重新确认', duration: 2 });
          } else {
            this.$toast.fail({ content: req.data.error_description, duration: 2 });
          }
        }
        resolve(null);
      });
    });
  },

  getHostByToken({ rootState, commit }, id) { // 根据token获取主办信息
    return new Promise((resolve, reject) => {
      api.get(`${config.https.api}/api/v1/host/current`, rootState.tokenHeaders).then(data => {
        if (data.data) { 
          commit('setHostInfo', data.data.data, { root: true });
          resolve(data.data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  getExhibitionById({ rootState, commit }, id) { // 根据展会id
    return new Promise((resolve, reject) => {
      api.get(`${config.https.api}/api/v1/exhibition?id=${id}`, rootState.header).then(data => {
        if (data.data) {
          commit('setExhibitionInfo', data.data.data, { root: true });
          resolve(data.data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  // 发送短信验证码
  sendCode({ }, opt) {
    return new Promise((resolve, reject) => {
      console.log(1, opt);
      api.post(`${config.https.api}/api/v1/sms/verificationcode`, opt).then(data => {
        if (data.data && data.status === 200) {
          resolve(data.data);
        } else {
          resolve([]);
        }
      }).catch(err => {resolve(false); console.log(err)});
    });
  },

  // 校验短信验证码
  validateCode({ }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.https.api}/api/v1/verificationcode/valid?key=${opt.key}&code=${opt.code}`, ).then(data => {
        console.log(data);
        if (data.data && data.status === 200) {
          console.log(
              "1"
          )
          resolve(data.data);
        } else {
          console.log(
              "2"
          )
          resolve(data.data);
        }
      }).catch(err => {resolve(false); console.log(err)});
    });
  },

  // 主办登录
  hostLogin({ }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.https.api}/api/authorize`, opt).then(data => {
        if (data.data && data.status === 200) {
          resolve(data.data);
        } else {
          resolve([]);
        }
      }).catch(err => {
        console.log(err);
      });
    });
  },

  // 获取主办用户信息
  getHostInfo({ rootState }) {
    return new Promise((resolve, reject) => {
      api.get(`${config.https.api}/api/userinfo`, { "headers": { "Authorization": "Bearer " + rootState.access_token, "api-version": 2 } }).then(data => {
        if (data.data && data.status === 200) {
          resolve(data.data);
        } else {
          resolve([]);
        }
      }).catch(err => console.log(err));
    });
  },

  // 获取观众用户信息
  getAudienceInfo({ commit, rootState }) {
    return new Promise((resolve, reject) => {
      api.get(`${config.https.api}/api/userinfo`, { "headers": { "Authorization": "Bearer " + rootState.access_token, "api-version": 1 } }).then(data => {
        if (data.data && data.status === 200) {
          commit('setUserId', data.data.Data.Id, { root: true });
          commit('setUserInfo', data.data.Data, { root: true });
          commit('setIsHasGetUser', true, { root: true });
          resolve(data.data);
        } else {
          commit('setIsHasGetUser', false, { root: true });
          resolve([]);
        }
      }).catch(err => console.log(err));
    });
  },
  memberUpdate({ rootState, commit } , opt) { //普通用户申请或修改专业买家
    // console.log(opt,id,'inMemberId')
    return new Promise((resolve, reject) => {
      api.post(`${config.https.api}/api/v1/member/update-professionalbuyer`,opt,rootState.header).then(data => {
        if (data.data) {
          console.log(data.data);
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
    toprofessionalbuyer({ rootState, commit } , opt) { //游客申请或修改专业买家
    // console.log(opt,id,'inMemberId')
    return new Promise((resolve, reject) => {
      api.post(`${config.https.api}/api/v1/member/update-toprofessionalbuyer`,opt,rootState.header).then(data => {
        if (data.data) {
          console.log(data.data);
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getMemberCurrent({ rootState, commit }, id) { // 根据展会id
    return new Promise((resolve, reject) => {
      api.get(`${config.https.api}/api/v1/member/current?exhibitionId=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getExhibitionSchedule({ rootState, commit }, id) { // 获取日程
    return new Promise((resolve, reject) => {
      api.get(`${config.https.api}/api/v1/exhibitionschedule/shorts?exhibitionId=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  // putMember({rootState, commit},id,opt){
  //   return new Promise((resolve, reject) => {
  //     api.get(`${config.https.api}/api/v1/member?id=${id}`, opt,rootState.header).then(data => {
  //       if (data.data) {
  //         resolve(data.data.data);
  //       } else {
  //         resolve(null);
  //       }
  //     }).catch((err) => {
  //       console.log(err);
  //     });
  //   });
  // }
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
